import { render, staticRenderFns } from "./LbaSection.vue?vue&type=template&id=2129b9ba"
import script from "./LbaSection.vue?vue&type=script&lang=js"
export * from "./LbaSection.vue?vue&type=script&lang=js"
import style0 from "./LbaSection.vue?vue&type=style&index=0&id=2129b9ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports